import type { Filter } from '../types'

export const ETF_FILTERS: Filter[] = [
    {
        name: 'Recycling and pollution reduction',
        emoji: '♻️',
        tag: '♻️ Recycling and pollution reduction',
        isPositive: true,
    },
    { name: 'Low emissions transport', emoji: '🚗', tag: '🚗 Low emissions transport', isPositive: true },
    { name: 'Renewable energy', emoji: '☀️', tag: '☀️ Renewable energy', isPositive: true },
    { name: 'Healthcare ', emoji: '🏥', tag: '🏥 Healthcare', isPositive: true },
    { name: 'Uranium and nuclear energy', emoji: '☢️', tag: '☢️ Uranium and nuclear energy', isPositive: false },
    { name: 'Junk food', emoji: '🍟', tag: '🍟 Junk food', isPositive: false },
    { name: 'Animal cruelty', emoji: '🐖', tag: '🐖 Animal cruelty', isPositive: false },
    { name: 'Weapons', emoji: '💣', tag: '💣 Weapons', isPositive: false },
    { name: 'Tobacco', emoji: '🚬', tag: '🚬 Tobacco', isPositive: false },
    { name: 'Gambling', emoji: '🎲', tag: '🎲 Gambling', isPositive: false },
    { name: 'Fossil fuels', emoji: '🛢️', tag: '🛢️ Fossil fuels', isPositive: false },
]

export const ETF_POSITIVE_FILTERS = ETF_FILTERS.filter((f) => f.isPositive)
export const ETF_NEGATIVE_FILTERS = ETF_FILTERS.filter((f) => !f.isPositive)

export default ETF_FILTERS
